<template>
    <div class="content mt20">
       <div class="account-content bgfff">
         <div class="one-bd clearfix">
            <a href="javascript:void(0);" :class="(typeId != 2&&typeId !=3)?'active':''" @click="listTab(1)">微信榜单</a>
            <a href="javascript:void(0);" :class="typeId==2?'active':''"  @click="listTab(2)">微博榜单</a>
            <a href="javascript:void(0);" :class="typeId==3?'active':''" @click="listTab(3)">头条榜单</a>
         </div>
       </div>
       <div class="account-bd">&nbsp;</div>
       <div class="bgfff">
            <div class="bd clearfix">
                <div class="btns-group time-tab fl">
                    <router-link :to="{path:'/mediaList',query:{id:3}}">头条号</router-link>
                    <router-link :class="this.typeId == 3?'active':''" :to="{path:'/mediaList/hotText',query:{id:3}}">热文</router-link>
                </div>
                <div class="btns-group time-tab ml20 fl">
                    <a  @click="dateListClick(1)" :class="currentTab1==1?'active':''" href="javascript:void(0);">日榜</a>
                    <a class="" @click="dateListClick(2)" :class="currentTab1==2?'active':''" href="javascript:void(0);">周榜</a>
                    <a class="" @click="dateListClick(3)" :class="currentTab1==3?'active':''" href="javascript:void(0);">月榜</a>
                </div>
                <div class="w194 ml25 form-time fl" v-if="currentTab1==1">
                    <vue-datepicker-local v-model="timeRange" format="YYYY-MM-DD" :disabled-date="disabledDate" showButtons  @confirm="selectedDate"/><i class="icons date-icon fr"></i>
                </div>
                <div class="dropdown-toggle w194 ml20 fl" v-if="currentTab1!=1">
                    <div class="dropdown">
                        <span>{{dateOne}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down w194">
                        <ul class="dropdown-menu dropdown-menu1" role="menu">
                            <li v-for="(item,index) in dateList" :key="index" @click="dateClick(item)">
                               <a href="javaScript:void(0)" :class="(dateOne==item?'active':'')">{{item}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="dropdown-toggle w194 ml20 fl">
                    <div class="dropdown">
                        <span>{{tagFont}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down w447">
                        <div class="search-warp w210">
                            <input type="text" name="search" placeholder="请输入标签名" class="input-text" v-model="searchSel"> 
                            <span class="search-btn" href="javascript:void(0);" @click="tagSearch">
                                <i class="icons search-icon1"></i>
                            </span>
                        </div>
                        <ul class="dropdown-menu" role="menu">
                            <li v-for="(item,index) in tagList" :key="index">
                               <a href="javaScript:void(0);" @click="tagClick(item.id,item.name)">{{item.name}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <a :href="Url" download="w3logo" v-if="totalCount<=200" class="btn btn-blue fr"><i class="icons icon-export"></i>导出</a>
                <button class="btn btn-blue fr" @click="exportBtn" v-if="totalCount>200"><i class="icons icon-export"></i>导出</button>
            </div>
            <div class="table-warp mt20">
                <table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
                    <colgroup>
                        <col width="">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>文章标题</th>
                            <th>头条号</th>
                            <th>总阅读数</th>
                            <th>总评论数</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="" v-if="nodata">
                            <td colspan="4"><div class="no-data" ><span class="text">没有数据哦...</span></div></td>
                        </tr>
                        <tr v-for="(item,index) in mediaList" :key="index">
                            <td>
                                <div class="ovhidden">
                                    <a :href="item.link" target="_blank">{{item.newsTitle}}</a>
                                </div>
                            </td>
                            <td>{{item.nickname}}</td>
                            <td>{{item.newsReadCount}}</td>
                            <td>{{item.newsCommentCount}}</td>
                        </tr>
                    </tbody>
                </table>
                 <!-- 分页 -->
                 <page class="mt20" :currentPage.sync="currentPage" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            </div>
       </div>
  	</div>
</template>
<script>
import Page from '@/components/page'
import Dialog from '@/components/dialog'
import VueDatepickerLocal from 'vue-datepicker-local'
export default {
    components: {Page,Dialog,VueDatepickerLocal},
    data() {
        return {
           typeId:'',//id
           mediaList:'',//热文列表
           currentTab1:1,//日榜type
           currentPage:1,//当前条数
           limit:10,//每页显示条数
           totalCount:0,//总条数
           sel:5,//Top 设置
           sel1:1,//文件类型
           customSel:'',//自定义选择
           dateOne:'',//选中时间
           timeRange:'',//默认日
           tagList:[],//标签
           tagFont:'全部',//标签默认
           searchSel:'',//标签搜索
           dateOne:'',//选中时间
           timeRange:'',//默认日
           dateList:[],//时间列表
           tagId:'',//标签id
           Url:'',//url
           totalNum:200,
           typeId:1,//id
           nodata:false,
        }
    },
    mounted() {
        let that = this;
        var myDate = new Date();
        myDate.setDate(myDate.getDate() - 1);
        that.timeRange = myDate.toLocaleDateString();
        that.typeId = that.$route.query.id;
        if(that.$route.query.type==undefined){
            that.currentTab1= that.currentTab1;
        }else{
            that.currentTab1= that.$route.query.type;
        }
        if(that.$route.query.type1==undefined){
            that.dateOne = that.dateOne;
        }else{
            that.dateOne = that.$route.query.type1;
        }
        that.dataAjax(0);
        that.dataAjax1();
    },
    created() {
		
    },
    methods: {
        tagSearch(){
            
        },
        tagClick(id,name){//标签选择
            let that =this;
            that.tagFont = name;
            that.tagId = id;
            let type = that.currentTab;
            that.dataAjax(type,1);
        },
         exportModal(){//导出弹框
            let that = this;
        },
        exportBtn(cPage){//导出确定
            let that = this;
             cPage = 1;
            let url = '/rank/ttarcimport';
            that.$api.post(url,{type:that.currentTab1,time:that.dateOne,flid:that.tagId},r=>{
                  that.$parent.returnCode(r,function(){

              })
            });
            that.$refs.exportDialog.closeMask();
        },
        dateClick(type1){//点击时间下拉
            let that = this;
            that.$router.push({
                path: '/mediaList/hotText',
                query: {
                    type:that.currentTab1,
                    type1: type1,             
                    id: 3,             
                }
            });
            that.dateOne = that.$route.query.type1;
            that.dataAjax(0);            

        },
        dateListClick(type1){//点击切换 日周月榜
            let that = this;
            that.currentTab1 = type1;
            if(type1==1){
                that.dateOne = that.timeRange;
                that.$router.push({
                    path: '/mediaList/hotText',
                    query: {
                        type: type1,
                        type1:that.dateOne,
                        id: 3,
                    }
                });
                that.currentTab1= that.$route.query.type;
                that.dataAjax(0);
            }else{
                that.$api.post('/rank/weekmonth',{type:that.currentTab1,source:that.currentTab},r=>{
                    that.$parent.returnCode(r,function(){
                        that.dateList = r.data;
                        that.dateOne = that.dateList[0];
                        that.$router.push({
                            path: '/mediaList/hotText',
                            query: {
                                id: 3,
                                type:type1,
                                type1:that.dateOne,
                            }
                        });
                        that.currentTab1= that.$route.query.type;
                        that.dataAjax(0);
                    //console.log(that.dateOne);
                    })
                })
            }
            
        },
        listTab(type){//点击切换 微信 微博 头条
            let that = this;
            that.currentTab = type;
            that.typeCurrent = 1;
            that.dateOne = '';
            that.dataAjax(type,0);
            that.$router.push({
                path: '/mediaList',
                query: {
                    id: that.currentTab
                }
            });
            that.typeId= that.$route.query.id;    
        },
        disabledDate(time,format){
            let that = this;
            if(time.getTime() > new Date().getTime()) return true;
        },
        selectedDate(date) {//点击日榜时间确定
            let that = this;
            that.dateOne = that.timeRange = that.$utils.dateConversion(that.timeRange,0);
            that.dataAjax(that.currentPage,0);
        },
        getTableData(){//分页
            let that = this;
            that.dataAjax(0);
        },
        dataAjax(cPage){//微信列表
            let that = this;
            if(cPage===0){
               that.currentPage = 1;
            }
            that.$parent.loadModal(true,'正在加载...');
            that.$api.post('/rank/ttarc',{page:that.currentPage,pagesize:that.limit,type:that.currentTab1,time:that.dateOne},r=>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.mediaList=r.data.list;
                    that.totalCount = Number(r.data.total);
                    //console.log(that.totalCount);
                    that.Url = r.data.url;   
                    if(that.mediaList.length<=0){
                        that.nodata = true;
                    }else{
                        that.nodata = false;
                    }
              })
            })
       },
       dataAjax1(type,cPage){//标签列表
            let that = this;
            let url = '/label/taglist';
            if(cPage===0){
               that.currentPage = 1;
            }
            that.$api.post(url,{type:that.currentTab},r=>{
                  that.$parent.returnCode(r,function(){
                   that.tagList=r.data;      
              })
            })
       },
       
	}
}
</script>




// WEBPACK FOOTER //
// src/page/mediaList/hotText.vue